module.exports = __webpack_public_path__ + "img/linkedin-icon.2c23b745.svg";